/* Mimi Shape shared behaviour. Loaded with defer on every page. */
(() => {
  const Mimi = (window.Mimi = window.Mimi || {});

  /* Numeric range markup, same as snippets/m-range.liquid */
  Mimi.range = (min, max, label) => {
    const bdi = document.createElement('bdi');
    bdi.dir = 'ltr';
    bdi.textContent = label ? `${label} (${min}–${max})` : `${min}–${max}`;
    return bdi;
  };

  /* Accordion (doc 1.4): button + aria-expanded + aria-controls. Works on markup:
     <div class="m-acc" data-m-acc>
       <div class="m-acc__item"><h3><button class="m-acc__btn" aria-expanded aria-controls="p1">…</button></h3>
       <div class="m-acc__panel" id="p1" role="region" aria-labelledby="…" hidden>…</div></div> */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.m-acc__btn');
    if (!btn) return;
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
  });
})();
